import {
  Box,
  Button,
  Flex,
  Text,
  useColorModeValue,
  useToken,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import IconBox from "components/Icons/IconBox";
import React from "react";
import { NavLink } from "react-router-dom";

const MotionIconWrap = motion.div;

const SidebarLink = React.memo(({ prop, isActive, onSignOut }) => {
  const att = {};
  if (!prop.signout) att.to = prop.path;
  const [sidebarSelect] = useToken("colors", ["sidebar_select_div"]);

  return (
    <NavLink {...att} onClick={prop.signout ? onSignOut : undefined}>
      <Box position="relative" w="100%" mb="4px" overflow="visible">
        {isActive && (
          <motion.div
            layoutId="active-sidebar"
            layout="position"
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 28,
              mass: 0.6,
            }}
            style={{
              position: "absolute",
              inset: 0,
              shadow: "2xl",
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              borderTopRightRadius: "12px",
              borderBottomRightRadius: "12px",
              background: sidebarSelect,
              overflow: "visible",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "-30px",
                left: 0,
                width: "35px",
                height: "30px",
                background: "transparent",
                borderBottomLeftRadius: "18px",
                boxShadow: `-8px 8px 0 ${sidebarSelect}`,
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-30px",
                left: 0,
                width: "35px",
                height: "30px",
                background: "transparent",
                borderTopLeftRadius: "18px",
                boxShadow: `-8px -8px 0 ${sidebarSelect}`,
              }}
            />
          </motion.div>
        )}

        <Button
          as={motion.button}
          whileHover={{ x: isActive ? 0 : -2 }}
          whileTap={{ scale: 0.97 }}
          transition={{ type: "spring", stiffness: 400, damping: 24 }}
          position="relative"
          zIndex="1"
          boxSize="initial"
          justifyContent="flex-start"
          alignItems="center"
          bg="transparent"
          w="87%"
          py="10px"
          ps="16px"
          borderRadius="8px"
          mb="0"
          _hover={{
            bg: isActive ? "transparent" : "sidebar_hover",
          }}
        >
          <Flex align="center">
            {/* آیکون هنگام فعال شدن یه کوچولو بزرگ‌تر میشه (پاپ نرم spring)،
                رنگ/بک‌گراندش هم به‌جای پرش خشک، با ترنزیشن نرم عوض میشه.
                نکته: اگه IconBox پراپ transition رو به المان اصلیش پاس نده،
                این خط بی‌اثر می‌مونه — کافیه داخل IconBox یه ...rest به Box بدی. */}
            <MotionIconWrap
              animate={{ scale: isActive ? 1.08 : 1 }}
              transition={{ type: "spring", stiffness: 400, damping: 18 }}
              style={{ display: "inline-flex" }}
            >
              <IconBox
                bg={
                  isActive
                    ? "sidebar_select_icon_bg"
                    : "sidebar_unselect_icon_bg"
                }
                color={
                  isActive
                    ? "sidebar_select_icon_color"
                    : "sidebar_unselect_icon_color"
                }
                h="30px"
                w="30px"
                me="12px"
                transition="background-color .25s ease, color .25s ease"
              >
                {prop.icon}
              </IconBox>
            </MotionIconWrap>

            <Text
              color={isActive ? "sidebar_select_text" : "sidebar_unselect_text"}
              my="auto"
              fontSize="sm"
              transition="color .25s ease"
            >
              {prop.name}
            </Text>
          </Flex>
        </Button>
      </Box>
    </NavLink>
  );
});

export default SidebarLink;